var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 8.29966V33.3332C29.5 34.1617 28.8284 34.8333 28 34.8333H2C1.17157 34.8333 0.5 34.1617 0.5 33.3333V8.29966C0.5 7.70688 0.849101 7.1697 1.39079 6.92895L14.3908 1.15117C14.7786 0.978793 15.2214 0.978793 15.6092 1.15117L28.6092 6.92895C29.1509 7.1697 29.5 7.70688 29.5 8.29966Z",
    stroke: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 27.5H17.3334C17.6096 27.5 17.8334 27.7239 17.8334 28V34.8333H12.1667V28C12.1667 27.7239 12.3906 27.5 12.6667 27.5Z",
    stroke: "#3C3C3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 9.1665,
    width: 7.33333,
    height: 5.66667,
    rx: 0.5,
    stroke: "#3C3C3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 17.5,
    width: 7.33333,
    height: 5.66667,
    rx: 0.5,
    stroke: "#3C3C3C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1667,
    y: 9.1665,
    width: 7.33333,
    height: 5.66667,
    rx: 0.5,
    stroke: "#3C3C3C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1667,
    y: 17.5,
    width: 7.33333,
    height: 5.66667,
    rx: 0.5,
    stroke: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCondo);
export default __webpack_public_path__ + "static/media/icon-condo.d1d40c9e25f95052518ce77b7ba7c740.svg";
export { ForwardRef as ReactComponent };